<template>
  <span v-if="value" :style="getStyle(moment)">
    <i v-if="iconClass" :class="iconClass + ' me-1'"></i>
    {{ moment(value, inputFormat).format(getFormat($page.props.locale)) }}
  </span>
</template>

<script>
export default {
  props: {
    value: { type: String, default: '' },
    inputFormat: { type: String, default: () => 'YYYY-MM-DD HH:mm:ss' },
    outputFormat: { type: String, default: () => null },
    invert: { type: Boolean, default: false },
    settings: { type: Object, default: () => ({ iconClass: true, diffColors: true }) },
  },
  setup(props) {
    const iconClass = props.settings.iconClass === true ? 'bi bi-calendar-fill' : props.settings.iconClass;

    const getFormat = (locale) => {
      if (props.outputFormat) {
        return props.outputFormat;
      }

      switch (locale) {
        case 'de':
          return 'DD.MM.YYYY HH:mm:ss';
        case 'en':
          return 'DD/MM/YYYY HH:mm:ss';
      }
    };

    const monthDiffColor = (moment) => {
      let diffInMonths = moment(props.value, props.inputFormat).diff(moment.now, 'months');
      let absDiffInMonths = Math.abs(diffInMonths);
      let maxMonths = 120;
      if (absDiffInMonths > maxMonths) {
        diffInMonths = diffInMonths === absDiffInMonths ? maxMonths : -maxMonths;
        absDiffInMonths = maxMonths;
      }
      let redValue = Math.round((absDiffInMonths / maxMonths) * 255);
      let greenValue = Math.round((1 - absDiffInMonths / maxMonths) * 255);
      let blueValue = 0;
      if (diffInMonths === absDiffInMonths) {
        blueValue = Math.round((diffInMonths / maxMonths) * 255);
      }
      let hexRed = Number(redValue).toString(16).padStart(2, '0');
      let hexGreen;
      if (absDiffInMonths > maxMonths / 2) {
        hexGreen = Number(greenValue).toString(16).padStart(2, '0');
        if (diffInMonths === absDiffInMonths) {
          hexRed = Number(greenValue).toString(16).padStart(2, '0');
        }
      } else {
        hexGreen = Number(redValue).toString(16).padStart(2, '0');
      }
      let hexBlue = Number(blueValue).toString(16).padStart(2, '0');

      return hexRed + hexGreen + hexBlue;
    };

    const yearDiffColor = (moment) => {
      let diffInYears = moment(props.value, props.inputFormat).diff(
        moment(moment().format('YYYY') + '-01-01', 'YYYY-MM-DD'),
        'years'
      );
      let absDiffInYears = Math.abs(diffInYears);
      let maxYears = 10;
      if (absDiffInYears > maxYears) {
        diffInYears = diffInYears === absDiffInYears ? maxYears : -maxYears;
        absDiffInYears = maxYears;
      }
      let redValue = Math.round((absDiffInYears / maxYears) * 255);
      let greenValue = Math.round((1 - absDiffInYears / maxYears) * 255);
      let blueValue = 0;
      if (diffInYears === absDiffInYears) {
        blueValue = Math.round((diffInYears / maxYears) * 255);
      }
      if (props.invert) {
        blueValue = Math.round((1 - absDiffInYears / maxYears) * 255);
        greenValue = Math.round(((absDiffInYears * 0.5) / maxYears) * 255);
        redValue = 255;
        if (diffInYears === absDiffInYears) {
          redValue = Math.round((1 - (diffInYears * 0.5) / maxYears) * 255);
          blueValue = 255;
          greenValue = Math.round((1 - (diffInYears * 0.5) / maxYears) * 255);
        }
      }

      let hexRed = Number(redValue).toString(16).padStart(2, '0');
      let hexGreen;
      if (absDiffInYears > maxYears / 2) {
        hexGreen = Number(greenValue).toString(16).padStart(2, '0');
        if (diffInYears === absDiffInYears) {
          hexRed = Number(greenValue).toString(16).padStart(2, '0');
        }
      } else {
        hexGreen = Number(redValue).toString(16).padStart(2, '0');
      }
      let hexBlue = Number(blueValue).toString(16).padStart(2, '0');

      return hexRed + hexGreen + hexBlue;
    };

    const getStyle = (moment) => {
      return props.settings.diffColors ? 'color: #' + yearDiffColor(moment) : '';
    };

    return {
      getFormat,
      getStyle,
      iconClass,
      monthDiffColor,
      yearDiffColor,
    };
  },
};
</script>
